import AdminSkillsPage from 'components/pages/admin/skills/admin-skills-page'

export default AdminSkillsPage
